import { useRef, useState } from 'react';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import styles from './FJToolItem.module.less';
import classNames from 'classnames';
import useLocalStore from '../../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJMoreIcon from '../../../../assets/svg/community/more.svg?react';
import FJUtil from '../../../../util/FJUtil';

const FJToolItem = props => {
    useLocalStore();

    const { data } = props;
    const { name, source, hoverEffect, desc, jumpLink } = data;

    const _video = useRef();
    const [isHoverBox, setIsHoverBox] = useState(false);
    const [isHover, setIsHover] = useState(false);

    const _onLoadedMetadata = () => {
        if (isHover && _video.current) {
            _video.current.play();
        }
    };

    const _onClick = () => {
        if (jumpLink) window.open(jumpLink, '_blank');
        FJUtil.eaLog('ai home tool click', {
            toolName: name.replaceAll('-', ' '),
        });
    };

    const _onMouseEnterBox = () => {
        setIsHoverBox(true);
        if (hoverEffect === 'play video') {
            setIsHover(true);
        }
    };

    const _onMouseLeaveBox = () => {
        setIsHoverBox(false);
        if (hoverEffect === 'play video') {
            setIsHover(false);
        }
    };

    return (
        <FJHoverBoardGradation
            className={styles.box}
            onClick={_onClick}
            contentClassName={styles.inner_box}
            active={isHoverBox}
            onMouseEnter={_onMouseEnterBox}
            onMouseLeave={_onMouseLeaveBox}
        >
            <div
                className={classNames(
                    styles.previewBox,
                    hoverEffect === 'play video' ? styles.play_video : styles.zoom_in,
                )}
            >
                <img src={source?.normal} alt={''} draggable='false' />
                {hoverEffect === 'play video' && isHover && (
                    <video ref={_video} src={source.hover} loop={true} muted onLoadedMetadata={_onLoadedMetadata} />
                )}
            </div>
            <div className={styles.content}>
                <div className={styles.content_left}>
                    <div className={styles.name}>{FJLocalStore._(name)}</div>
                    <div className={styles.desc}>{FJLocalStore._(desc)}</div>
                </div>
                <div className={styles.content_right}>
                    <FJMoreIcon className={styles.moreIcon} />
                </div>
            </div>
        </FJHoverBoardGradation>
    );
};

FJToolItem.propTypes = {
    data: PropTypes.object.isRequired,
};

export default FJToolItem;
